import { ref, watch } from 'vue';
import { createSharedComposable, useDebounceFn } from '@vueuse/core';

const emptyResults = { clients: [], vehicles: [], invoices: [] };

function _useGlobalSearch() {
    const open = ref(false);
    const query = ref('');
    const results = ref({ ...emptyResults });
    const loading = ref(false);

    const openSearch = () => {
        open.value = true;
    };

    const closeSearch = () => {
        open.value = false;
        query.value = '';
        results.value = { ...emptyResults };
    };

    const performSearch = useDebounceFn(async (searchQuery) => {
        if (!searchQuery || searchQuery.length < 2) {
            results.value = { ...emptyResults };
            loading.value = false;

            return;
        }

        loading.value = true;

        try {
            const response = await window.axios.get(route('api.search'), {
                params: { query: searchQuery },
            });

            results.value = response.data;
        } catch {
            results.value = { ...emptyResults };
        } finally {
            loading.value = false;
        }
    }, 250);

    watch(query, (value) => {
        if (value.length >= 2) {
            loading.value = true;
        }

        performSearch(value);
    });

    return {
        open,
        query,
        results,
        loading,
        openSearch,
        closeSearch,
    };
}

export const useGlobalSearch = createSharedComposable(_useGlobalSearch);
